export const PRELOAD_DATA = 'PRELOAD_DATA';
